import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    lng: "fr",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
    resources: {
        fr: {
            translation: {
                "datetime_start": "Date de début",
                "datetime_end": "Date de fin",
                "post": "Post",
                "comment": "Commentaire",
                "comments": "Commentaires",
                "type": "Type",
                "user": "Utilisateur",
                "datetime": "Date",
                "content": "Contenu",
                "wind": "Vent",
                "temperature": "Température",
                "humidity": "Humidité",
                "pressure": "Pression",
                "clouds": "Nuages",
                "rain": "Pluie",
                "snow": "Neige",
                "weather": "Météo",
                "quantity": "Quantité",
                "coverage": "Pourcentage couvert",
                "Home": "Accueil",
                "Users": "Utilisateurs",
                "Email": "Email",
                "Username": "Nom d'utilisateur",
                "Role": "Rôle",
                "cancel": "Annuler",
                "upload": "Téléverser",
                "create": "créer",
                "Create Folder": "Créer un dossier",
                "Password": "Mot de passe",
                "Email Verified": "Email vérifié",
                'First Name': "Prénom",
                'Last Name': "Nom",
                "Settings": "Paramètres",
                "Language": "Langue",
                "Dark mode": "Mode sombre",
                "Submit": "Soumettre",
                "Admin": "Administrateur",
                "Choose your MFA method": "Choisissez votre méthode d'authentification à deux facteurs",
                "totp": "Application d'authentification",
                "MFA is now configured": "L'authentification à deux facteurs est maintenant configurée",
                "MFA is already configured": "L'authentification à deux facteurs est déjà configurée",
                "Configure TOTP": "Configurer TOTP",
                "Configure MFA": "Configurer l'authentification à deux facteurs",
                "Scan the QR code with your TOTP application": "Scannez le QR code avec votre application TOTP (Google Authenticator, Microsoft Authenticator, etc.)",
                "Or enter the secret key": "Ou entrez la clé secrète",
                "MFA us now configured": "L'authentification à deux facteurs est maintenant configurée",
                "folder": "dossier",
                "delete": "supprimer",
                "edit": "Modifier",
                "Are you sure you want to delete this file or folder?": "Êtes-vous sûr de vouloir supprimer ce fichier ou ce dossier?",
                "This action cannot be undone.": "Cette action ne peut pas être annulée.",
                "Repository": "Répertoire",
                "name": "Nom",
                "This password is too short. It must contain at least 8 characters.": "Ce mot de passe est trop court. Il doit contenir au moins 8 caractères.",
                "This password is too common.": "Ce mot de passe est trop commun.",
                "This password is entirely numeric.": "Ce mot de passe est entièrement numérique.",
                "This password is too similar to the email address.": "Ce mot de passe est trop similaire à l'adresse email.",
                "This password is too similar to the first name.": "Ce mot de passe est trop similaire au prénom.",
                "Passwords do not match.": "Les mots de passe ne correspondent pas.",
                "New password must be different from the old password.": "Le nouveau mot de passe doit être différent de l'ancien.",
                "Old password is invalid.": "L'ancien mot de passe est invalide.",
                "New password must be different from old password.": "Le nouveau mot de passe doit être différent de l'ancien.",
                "email": "Email",
                "by": "par",
                "Verify your MFA": "Vérifiez votre authentification à deux facteurs",
                "A code has been sent to your email": "Un code a été envoyé à votre email",
                "Open your authenticator app and enter the code": "Ouvrez votre application d'authentification et entrez le code",
                "Resend code": "Renvoyer le code",
                "Files": "Fichiers",
                "No notifications": "Aucune notification",
                'Page not found': "Page non trouvée",
                "Go to Home": "Aller à l'accueil",
                "Verify": "Vérifier",
                "Mark all as read": "Tout marquer comme lu",
                "Delete all": "Tout supprimer",
                "safe folder": "dossier sécurisé",
                "Folder name": "Nom du dossier",
                "You need to unlock the folder first": "Vous devez d'abord déverrouiller le dossier",
                "Folder must be unlocked first": "Le dossier doit d'abord être déverrouillé",
                "Add": "Ajouter",
                "a": "un",
                "Why use secure folders?": "Pourquoi utiliser des dossiers sécurisés?",
                "Secure folders are encrypted and can only be accessed by you. Every file you upload to a secure folder is encrypted with a key derived from your password.": "Les dossiers sécurisés sont chiffrés et ne peuvent être accédés que par vous. Chaque fichier que vous téléversez dans un dossier sécurisé est chiffré avec une clé dérivée de votre mot de passe.",
                "If you forget your password, you will not be able to access your files. Even the administrator of the server cannot access your files.": "Si vous oubliez votre mot de passe, vous ne pourrez pas accéder à vos fichiers. Même l'administrateur du serveur ne peut pas accéder à vos fichiers.",
                "New file": "Nouveau fichier",
                "New folder": "Nouveau dossier",
                "Favorite folders only": "Dossiers préférés uniquement",
                "Notification settings": "Paramètres de notification",
                "Save": "Enregistrer",
                "Email notifications": "Notifications par email",
                "In-app notifications": "Notifications dans l'application",
                "Recent folders": "Dossiers récents",
                "Favorite folders": "Dossiers préférés",
                "Confirm password": "Confirmez le mot de passe",
                "Email address": "Adresse email",
                "Email already exists": "L'adresse email existe déjà",
                "Password changed": "Mot de passe changé",
                "New password must be different than the old password.": "Le nouveau mot de passe doit être différent de l'ancien.",
                "Invalid code": "Code invalide",
                "Passwords do not match.": "Les mots de passe ne correspondent pas.",
                "Invalid password": "Mot de passe invalide",
                "New password": "Nouveau mot de passe",
                "Current password": "Mot de passe actuel",
                "Back to settings": "Retour aux paramètres",
                "Enter the code generated by your Authenticator application": "Entrez le code généré par votre application Authenticator",
                "Clear": "Effacer",
                "Are you sure you want to delete these files or folders?": "Êtes-vous sûr de vouloir supprimer ces fichiers ou dossiers?",
                "Delete": "Supprimer",
                "Are you sure you want to delete this user?": "Êtes-vous sûr de vouloir supprimer cet utilisateur?",
                "This action cannot be undone.": "Cette action ne peut pas être annulée.",
                "Upload files": "Téléverser des fichiers",
                "Do you want to upload these files?": "Voulez-vous téléverser ces fichiers?",
                "You can add recipients to the files": "Vous pouvez ajouter des destinataires aux fichiers",
                "Recipients": "Destinataires",
                "Upload": "téléverser",
                "resend email": "Renvoyer l'email",
                "You can resend the account creation email to this user if they did not receive it or if they lost their password.": "Vous pouvez renvoyer l'email de création de compte à cet utilisateur s'ils ne l'ont pas reçu ou s'ils ont perdu leur mot de passe.",
                "Move selection": "Déplacer la sélection",
                "Move": "Déplacer",
                "Files moved": "Fichiers déplacés",
                "Error moving files": "Erreur lors du déplacement des fichiers",
                "Login": "Connexion",
                "Search": "Rechercher",
                "Catalog": "Catalogue",
                "System Number": "Numéro de système",
                "System": "Système",
                "DB Extract Date": "Date d'extraction de la base de données",
                "SAP to DB Date": "Date de SAP à DB",
                "Extract By": "Extrait par",
                "New Text": "Nouveau texte",
                "On Web": "Sur le Web",
                "French Name": "Nom français",
                "English Name": "Nom anglais",
                "Preliminary Import": "Importation préliminaire",
                "Image Name": "Nom de l'image",
                "Import ID": "ID d'importation",
                "Imported At": "Importé à",
                "Note": "Remarque",
                "Model": "Modèle",
                "SAP Extraction Date": "Date d'extraction de SAP",
                "BOM file": "Fichier BOM",
                "Search a image number or a vehicle SKU": "Rechercher un numéro d'image ou un SKU de véhicule",
                "Yes": "Oui",
                "No": "Non",
                "Search results for": "Résultats de recherche pour",
                "Last Visit": "Dernière visite",
                "Last City": "Dernière ville",
                "Last Country": "Dernier pays",
                "Last IP": "Dernière IP",
                "Exportation Date": "Date d'exportation",
                "Search Image": "Rechercher une image",
                "Search a system number": "Rechercher un numéro de système",
                'Done Systems': "Systèmes terminés",
                'Current Data Extraction Date': "Date d'extraction de données actuelle",
                'This is the last extraction date for each system number currently in our system': 'Ceci est la dernière date d\'extraction pour chaque numéro de système actuellement dans notre système',
                'If someone is currently working on a system, they likely have data extracted at this date or before': "Si quelqu'un travaille actuellement sur un système, il a probablement des données extraites à cette date ou avant",
                'This is useful to know if a system is currently being worked on': "Cela est utile si un système est actuellement en cours de traitement",
                'An error occured while fetching data': "Une erreur s'est produite lors de la récupération des données",
                'Can search Image': "Peut rechercher une image",
                'Can search by system number': "Peut rechercher par numéro de système",
                'Can search User': "Peut rechercher un utilisateur",
                'Can search Permission': "Peut rechercher une permission",
                "Can manage import": "Peut gérer l'importation",
                'Multiple permissions': "Permissions multiples",
                'No permissions': "Aucune permissions",
                "Can use notice of change": "Peut utiliser les avis de changements",
                "Notice of Change": "Avis de changement",
                "Progress": "Progression",
                "Can read progress": "Peut consulter la progression",
                "Can manage progress": "Peut gérer la progression",
                "Edit Progress": "Modif. progression",
                "Update Progress": "Mise à jour de la progression",
                "Done On": "Terminé le",
                "Done": "Terminé",
                "Number of done platforms": "Nombre de plateformes terminées",
                "Number of platforms with this system": "Nombre de plateformes avec ce système",
                "Production Calendar": "Calendrier de production",
                "Month": "Mois",
                "Planned": "Planifié",
                "Actual": "Réel",
                "Add row": "Ajouter une ligne",
                "Year": "Année",
                "System Done by Month": "Systèmes terminés par mois",
                "Model Year": "Année modèle",
                "Advanced search": "Recherche avancée",
                "Or": "Ou",
                "Vehicle": "Véhicule",
                "Cancel": "Annuler",
                "Datagrid": "Grille de données",
                "Gallery": "Galerie",
                "Datagrid by image": "Grille de données par image",
                "One row by image": "Une seule ligne par image",
                "Both": "Les deux",
                "Side by side": "Côte à côte",
                "Close": "Fermer",
                "This is an experimental feature, it works best if the images are similar.": "Il s'agit d'une fonctionnalité expérimentale, elle fonctionne mieux si les images sont similaires.",
                "Glossary": "Glossaire",
                "Can view lexicon": "Peut consulter le glossaire",
                "Can edit lexicon": "Peut modifier le glossaire",
                "Planned Hours": "Heures planifiées",
                "Actual Hours": "Heures réelles",
                "SKI": "Ski-Doo",
                "SEA": "Sea-Doo",
                "NTC": "Lynx",
                "ATV": "ATV",
                "SSV": "SSV",
                "SPY": "On-Road",
                "Planned Systems to Date": "Systèmes planifiés à ce jour",
                "Done Systems to Date": "Systèmes terminés à ce jour",
                "Planned Hours to Date": "Heures planifiées à ce jour",
                "Done Hours to Date": "Heures réelles à ce jour",
                'Please select at least one label (color) in the chart below to see progress.': "Veuillez sélectionner au moins une étiquette (couleur) dans le graphique ci-dessous pour voir la progression.",
                "3D Viewer": "Visionneuse 3D",
                "2D Viewer": "Visionneuse 2D",
                "Fullscreen": "Plein écran",
                "Exit Fullscreen": "Quitter le plein écran",
                "Manage Image": "Gérer l'image",
                "3D Viewer URL": "URL de la visionneuse 3D",
                "Can edit image": "Peut modifier l'image",
                "View": "Voir",
                "in 3D": "en 3D",
                "BOMs by year": "BOMs par année",
                "Images by year": "Images par année",
                "Total parts": "Total des pièces",
                "Total unique parts": "Total des pièces uniques",
                "This number is the sum of all parts in all BOMs.": "Ce nombre est la somme de toutes les pièces dans tous les BOMs.",
                "This number is the sum of all different parts in all BOMs.": "Ce nombre est la somme de toutes les pièces différentes dans tous les BOMs.",
                "SKUs by year": "SKUs par année",
                "Images by serie": "Images par série",
                "Can view statistics": "Peut consulter les statistiques",
                "success": "succès",
                "error": "erreur",
                "Permissions Groups": "Groupes de permissions",
                "Choices": "Choix",
                "selected": "sélectionné(s)",
                "Chosen": "Choisi",
                "Groups": "Groupes",
                "This choice is already in the group": "Ce choix est déjà dans le groupe",
                "Status Statistics": "Statistiques de statut",
                "Status Statistics for": "Statistiques de statut pour",
                "Number of parts with status code 2-M": "Nombre de pièces avec le code de statut 2-M",
                "Number of parts with status code 3": "Nombre de pièces avec le code de statut 3",
                "Platform": "Plateforme",
                "Serie": "Série",
                "Can view part status": "peut consulter les statuts des pièces",
                "Part Status": "Statut des pièces",
                "Reset scale": "Réinitialiser l'échelle",
                "Parts": "Pièces",
                "Delete all": "Supprimer tout",
                "Mark all as read": "Marquer tout comme lu",
                "Send notifications by email": "Envoyer les notifications par email",
                "Release Date": "Date de sortie",
                "Ref Number": "Numéro de référence",
                "Part Number": "Numéro de pièce",
                "English Description": "Description en anglais",
                "French Description": "Description en français",
                "Change shown content": "Modifier le contenu affiché",
                "Usage Statistics": "Statistiques d'utilisation",
                "Today's Page Views": "Vues de pages d'aujourd'hui",
                "Active Users Today": "Utilisateurs actifs aujourd'hui",
                "API Requests Today": "Requêtes API d'aujourd'hui",
                "Searches Today": "Recherches d'aujourd'hui",
                "Overview": "Aperçu",
                "My Analytics": "Mes analyses",
                "Admin Analytics": "Analyses administrateur",
                "Performance": "Performance",
                "Date Range": "Plage de dates",
                "Last 7 days": "7 derniers jours",
                "Last 30 days": "30 derniers jours",
                "Last 3 months": "3 derniers mois",
                "Page Views (Last 30 Days)": "Vues de pages (30 derniers jours)",
                "Search Patterns": "Recherches fréquentes",
                "Most Used Endpoints": "Appels API les plus utilisés",
                "Most Active Users": "Utilisateurs les plus actifs",
                "My Page Views": "Mes vues de pages",
                "My Feature Usage": "Mon utilisation des fonctionnalités",
                "My Search History": "Mon historique de recherche",
                "Daily Active Users": "Utilisateurs actifs quotidiens",
                "Feature Popularity": "Popularité des fonctionnalités",
                "User Engagement Dashboard": "Tableau de bord d'engagement utilisateur",
                "API Performance": "Performance de l'API",
                "Requests": "Requêtes",
                "Page Views": "Vues de pages",
                "API Calls": "Appels API",
                "Searches": "Recherches",
                "Features": "Fonctionnalités",
                "Engagement Score": "Score d'engagement",
                "Engagement Score Breakdown": "Détail du score d'engagement",
                "API Requests": "Requêtes API",
                "Features Used": "Fonctionnalités utilisées",
                "Consistency": "Consistance",
                "Recency": "Récence",
                "Total": "Total",
                "days ago": "jours",
                "Avg Response Time (ms)": "Temps de réponse moyen (ms)",
                "requests": "requêtes",
                "searches": "recherches",
                "yesterday": "hier",
                "vs yesterday": "vs hier",
                "searches": "recherches",
                "{{count}} searches": "{{count}} recherche(s)",
                "{{count}} requests": "{{count}} requête(s)",
                "Price USD": "Prix USD",
                "Can view prices": "Peut consulter les prix",
                "Part Settings": "Paramètres de la pièces",
                "Part Color": "Couleur de la pièce",
                "Save settings": "Enregistrer les paramètres",

                // Access Rules translations
                "Access Rules": "Règles d'accès",
                "New Rule": "Nouvelle règle",
                "Edit Rule": "Modifier la règle",
                "Create Rule": "Créer une règle",
                "Rule Name": "Nom de la règle",
                "Enter a descriptive name for this rule": "Entrez un nom descriptif pour cette règle",
                "Allow Access": "Autoriser l'accès",
                "Deny Access": "Refuser l'accès",
                "Users/groups will see records matching the filters below": "Les utilisateurs/groupes verront les enregistrements correspondant aux filtres ci-dessous",
                "Users/groups will NOT see records matching the filters below": "Les utilisateurs/groupes ne verront PAS les enregistrements correspondant aux filtres ci-dessous",
                "Filters": "Filtres",
                "Leave filters empty to apply to all records. Set specific values to limit scope.": "Laissez les filtres vides pour appliquer à tous les enregistrements. Définissez des valeurs spécifiques pour limiter la portée.",
                "Apply to": "Appliquer à",
                "Allow": "Autoriser",
                "Deny": "Refuser",
                "No filters (all records)": "Aucun filtre (tous les enregistrements)",
                "No targets": "Aucune cible",
                "Unnamed rule": "Règle sans nom",
                "Applies to": "S'applique à",
                "Confirm Delete": "Confirmer la suppression",
                "Are you sure you want to delete the rule": "Êtes-vous sûr de vouloir supprimer la règle",
                "An error occurred": "Une erreur s'est produite",
                "Operation completed successfully": "Opération terminée avec succès",
                "Next Image": "Image suivante",
                "Previous Image": "Image précédente",

                //
                "Compare": "Comparer",
                "import.bulk.title": "Importation manuelle",
                "import.bulk.masterReminderFile": "Fichier Master Reminder (.xlsx)",
                "import.bulk.masterReminderDescription": "Un seul fichier Excel contenant les lignes Master Reminder",
                "import.bulk.assets": "Assets (BOMs + Images)",
                "import.bulk.assetsDescription": "Déposez ensemble: BOM (.xlsx) et Images (.tif/.png/.jpg)",
                "import.bulk.assetsCaption": "{{boms}} BOM | {{images}} images",
                "import.bulk.preview": "Prévisualiser",
                "import.bulk.repreview": "Re‑prévisualiser",
                "import.bulk.import": "Importer",
                "import.bulk.info": "Sélectionnez vos fichiers (Master reminder + Assets) puis cliquez sur Prévisualiser.",
                "import.bulk.summary": "Résumé",
                "import.bulk.mrLines": "MR lignes",
                "import.bulk.bomFiles": "BOM fichiers",
                "import.bulk.images": "Images",
                "import.bulk.missingBoms": "BOM manquants",
                "import.bulk.missingImages": "Images manquantes",
                "import.bulk.totalBomLines": "Total lignes BOM",
                "import.bulk.uniqueParts": "Pièces uniques",
                "import.bulk.mrRowsTitle": "Lignes Master Reminder",
                "import.bulk.table.catalog": "Catalog",
                "import.bulk.table.system": "System",
                "import.bulk.table.bom": "BOM",
                "import.bulk.table.bomLines": "Lignes BOM",
                "import.bulk.table.uniqueParts": "Pièces uniq.",
                "import.bulk.table.image": "Image",
                "import.bulk.table.status": "Status",
                "import.bulk.status.bomMissing": "BOM ?",
                "import.bulk.status.bomOk": "BOM OK",
                "import.bulk.status.imgMissing": "IMG ?",
                "import.bulk.status.imgOk": "IMG OK",
                "import.bulk.alert.missing": "Certains éléments référencés ne trouvent pas de fichier correspondant. Ils seront ignorés.",
                "import.bulk.alert.allFound": "Tous les fichiers référencés ont été trouvés.",
                "import.bulk.result.title": "Résultat Import",
                "import.bulk.result.created": "Entrées créés",
                "import.bulk.result.updated": "Entrées m.a.j",
                "import.bulk.result.bom": "BOM",
                "import.bulk.result.bomLines": "Lignes BOM",
                "import.bulk.result.parts": "Pièces",
                "import.bulk.result.images": "Images",
                "import.bulk.result.hotspots": "Hotspots",
                "import.bulk.result.finish": "Terminer",
                "dragDrop.defaultLabel": "Déposez les fichiers",
                "dragDrop.browse": "Parcourir",
                "dragDrop.filesSelected_one": "{{count}} fichier sélectionné",
                "dragDrop.filesSelected_other": "{{count}} fichiers sélectionnés",
                "import.bulk.help.title": "Instructions d’importation",
                "import.bulk.help.intro": "Préparez un fichier Master Reminder, vos BOMs (.xlsx) et les images associées, puis lancez la prévisualisation. Le système détecte automatiquement BOM et images.",
                "import.bulk.help.steps.title": "Étapes",
                "import.bulk.help.steps.1": "1. Téléchargez le modèle (ou adaptez votre fichier existant) avec les colonnes requises. ",
                "import.bulk.help.steps.2": "2. Ajoutez vos lignes \"Master Reminder\" (une par système). Prenez soin d'entrer un nom de système unique pour le catalogue, sinon il sera écrasé.",
                "import.bulk.help.steps.3": "3. Placez les fichiers BOM (.xlsx) et les images dans la zone Assets. Les noms doivent correspondre aux colonnes BOM Name et Image Name.",
                "import.bulk.help.steps.4": "4. Cliquez sur Prévisualiser, corrigez au besoin, puis Importer.",
                "import.bulk.help.columns.title": "Colonnes Master Reminder",
                "import.bulk.help.columns.required": "Requises: Catalog, System",
                "import.bulk.help.columns.optional": "Optionnelles: System Number, FR Name, EN Name, Note, BOM Name, Image Name, On Web, Model",
                "import.bulk.help.downloadTemplate": "Télécharger le modèle",
                "import.bulk.help.sampleBomTitle": "Format BOM attendu",
                "import.bulk.help.sampleBomCols": "Colonnes: Ref #, Item, Part Number, Description - English, Description - French, Qty",
                "import.bulk.help.assetsNote": "Les noms BOM et Image doivent correspondre (sans extension) aux entrées Master Reminder.",
                "User Groups": "Groupes d'utilisateurs",
                "SKU Groups": "Groupes de SKUs",
                "New Group": "Nouveau groupe",
                "Use the search and filter tools below to find specific SKUs. Click column headers to sort.": "Utilisez la recherche et les filtres ci-dessous pour trouver des SKUs spécifiques. Appuyez sur les entêtes de colonnes pour trier.",
                "Selected SKUs": "SKUs sélectionnés",
                "Edit SKU Group": "Modifier le groupe de SKUs",
                "Create SKU Group": "Créer un groupe de SKUs",
                "Select All": "Sélectionner tout",
                "Deselect All": "Déselectionner tout",
                "Group Name": "Nom du groupe",
                "tutorials.title": "Tutoriels vidéo",
                "tutorials.video": "Vidéo",
                "tutorials.noVideos": "Aucun tutoriel vidéo disponible",
                "tutorials.completed": "Terminé",
                "tutorials.inProgress": "En cours",
                "tutorials.playlist": "Liste de lecture",
                "tutorials.nowPlaying": "En lecture",
                "tutorials.selectVideo": "Sélectionnez une vidéo dans la liste",
                "Last Seen On: ": "Dernière consultation: ",
                "Completed On: ": "Terminé le: ",
                "Tutorials": "Tutoriels"
            }
        },
        en: {
            translation: {
                "totp": "Authenticator App",
                "email": "Email",
                "by": "by",
                "resend email": "Resend Email",
                "Can view lexicon": "Can view Glossary",
                "Can edit lexicon": "Can edit Glossary",
                "SKI": "Ski-Doo",
                "SEA": "Sea-Doo",
                "NTC": "Lynx",
                "ATV": "ATV",
                "SSV": "SSV",
                "SPY": "On-Road",
                "{{count}} searches": "{{count}} search(es)",
                "{{count}} requests": "{{count}} request(s)",

                // Access Rules translations (English - most are already in English in the component)
                "Access Rules": "Access Rules",
                "New Rule": "New Rule",
                "Edit Rule": "Edit Rule",
                "Create Rule": "Create Rule",
                "Rule Name": "Rule Name",
                "Enter a descriptive name for this rule": "Enter a descriptive name for this rule",
                "Allow Access": "Allow Access",
                "Deny Access": "Deny Access",
                "Users/groups will see records matching the filters below": "Users/groups will see records matching the filters below",
                "Users/groups will NOT see records matching the filters below": "Users/groups will NOT see records matching the filters below",
                "Filters": "Filters",
                "Leave filters empty to apply to all records. Set specific values to limit scope.": "Leave filters empty to apply to all records. Set specific values to limit scope.",
                "Apply to": "Apply to",
                "Allow": "Allow",
                "Deny": "Deny",
                "No filters (all records)": "No filters (all records)",
                "No targets": "No targets",
                "Unnamed rule": "Unnamed rule",
                "Applies to": "Applies to",
                "Confirm Delete": "Confirm Delete",
                "Are you sure you want to delete the rule": "Are you sure you want to delete the rule",
                "An error occurred": "An error occurred",
                "Operation completed successfully": "Operation completed successfully",
                "import.bulk.title": "Manual Import",
                "import.bulk.masterReminderFile": "Master Reminder file (.xlsx)",
                "import.bulk.masterReminderDescription": "Single Excel file containing Master Reminder rows",
                "import.bulk.assets": "Assets (BOMs + Images)",
                "import.bulk.assetsDescription": "Drop together: BOM (.xlsx) and Images (.tif/.png/.jpg)",
                "import.bulk.assetsCaption": "{{boms}} BOM | {{images}} images",
                "import.bulk.preview": "Preview",
                "import.bulk.repreview": "Re‑preview",
                "import.bulk.import": "Import",
                "import.bulk.info": "Select your files (Master reminder + Assets) then click Preview.",
                "import.bulk.summary": "Summary",
                "import.bulk.mrLines": "MR rows",
                "import.bulk.bomFiles": "BOM files",
                "import.bulk.images": "Images",
                "import.bulk.missingBoms": "Missing BOM",
                "import.bulk.missingImages": "Missing Images",
                "import.bulk.totalBomLines": "Total BOM lines",
                "import.bulk.uniqueParts": "Unique parts",
                "import.bulk.mrRowsTitle": "Master Reminder Rows",
                "import.bulk.table.catalog": "Catalog",
                "import.bulk.table.system": "System",
                "import.bulk.table.bom": "BOM",
                "import.bulk.table.bomLines": "BOM Lines",
                "import.bulk.table.uniqueParts": "Unique Parts",
                "import.bulk.table.image": "Image",
                "import.bulk.table.status": "Status",
                "import.bulk.status.bomMissing": "BOM ?",
                "import.bulk.status.bomOk": "BOM OK",
                "import.bulk.status.imgMissing": "IMG ?",
                "import.bulk.status.imgOk": "IMG OK",
                "import.bulk.alert.missing": "Some referenced items have no matching file. They will be ignored.",
                "import.bulk.alert.allFound": "All referenced files were found.",
                "import.bulk.result.title": "Import Result",
                "import.bulk.result.created": "Entries created",
                "import.bulk.result.updated": "Entries updated",
                "import.bulk.result.bom": "BOM",
                "import.bulk.result.bomLines": "BOM Lines",
                "import.bulk.result.parts": "Parts",
                "import.bulk.result.images": "Images",
                "import.bulk.result.hotspots": "Hotspots",
                "import.bulk.result.finish": "Finish",
                "import.bulk.result.finish": "Finish",
                "dragDrop.defaultLabel": "Drop files here",
                "dragDrop.browse": "Browse",
                "dragDrop.filesSelected_one": "{{count}} file selected",
                "dragDrop.filesSelected_other": "{{count}} files selected",
                "import.bulk.help.title": "Import Instructions",
                "import.bulk.help.intro": "Prepare a Master Reminder file, your BOM (.xlsx) files and related images, then run preview. The system auto-detects BOM vs images.",
                "import.bulk.help.steps.title": "Steps",
                "import.bulk.help.steps.1": "1. Download the template (or adapt your existing sheet) with required columns.",
                "import.bulk.help.steps.2": "2. Add your Master Reminder rows (one per system). Take care to enter a unique system name per catalog, otherwise it will be overwritten.",
                "import.bulk.help.steps.3": "3. Drop BOM (.xlsx) files and images together into the Assets area.",
                "import.bulk.help.steps.4": "4. Click Preview, adjust if needed, then Import.",
                "import.bulk.help.columns.title": "Master Reminder Columns",
                "import.bulk.help.columns.required": "Required: Catalog, System",
                "import.bulk.help.columns.optional": "Optional: System Number, FR Name, EN Name, Note, BOM Name, Image Name, On Web, Model",
                "import.bulk.help.downloadTemplate": "Download template",
                "import.bulk.help.sampleBomTitle": "Expected BOM format",
                "import.bulk.help.sampleBomCols": "Columns: Ref #, Item, Part Number, Description - English, Description - French, Qty",
                "import.bulk.help.assetsNote": "BOM Name and Image Name must match (without extension) the provided Master Reminder entries.",
                
                "tutorials.title": "Video Tutorials",
                "tutorials.video": "Video",
                "tutorials.noVideos": "No video tutorials available",
                "tutorials.completed": "Completed",
                "tutorials.inProgress": "In Progress",
                "tutorials.playlist": "Playlist",
                "tutorials.nowPlaying": "Now Playing",
                "tutorials.selectVideo": "Select a video from the playlist",
            }
        }
    },
});

export default i18n;